// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__loNQp","noImage":"Hero_noImage__gxnfd","title":"Hero_title__w41Zv","author":"Hero_author__KurNc","lead":"Hero_lead__uQCtx","image":"Hero_image__pIFuf"};